import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    slot: {
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0
    }
});

export const useStyles = ({
    slotWidth
}: {
    slotWidth: number;
}) => {
    const styles = {
        slot: {
            width: slotWidth
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
